var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnythingElse2Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9213 15.6563C17.6883 14.8903 15.2628 14.8958 13.0333 15.672C12.8712 15.7299 12.727 15.8289 12.6149 15.9594C12.5027 16.0899 12.4265 16.2474 12.3937 16.4163L11.6564 20.1048C11.6238 20.2679 11.551 20.4203 11.4446 20.5482C11.3383 20.6761 11.2017 20.7755 11.0472 20.8372L5.13312 23.2029C4.93275 23.2838 4.71152 23.2973 4.50276 23.2416C4.294 23.1858 4.10902 23.0637 3.97569 22.8936C3.08264 21.7389 2.64112 20.2982 2.73379 18.8414C2.82646 17.3846 3.44698 16.0115 4.47914 14.9792C7.66726 11.7911 11.9913 10 16.5 10C21.0086 10 25.3326 11.7911 28.5208 14.9792C29.5529 16.0115 30.1734 17.3846 30.2661 18.8414C30.3588 20.2982 29.9173 21.7389 29.0242 22.8936C28.8909 23.0637 28.7059 23.1858 28.4972 23.2416C28.2884 23.2973 28.0672 23.2838 27.8668 23.2029L21.9476 20.8352C21.7945 20.7739 21.6589 20.6758 21.5529 20.5495C21.4469 20.4231 21.3738 20.2726 21.3401 20.1111L20.5637 16.3939C20.5296 16.2259 20.4525 16.0696 20.3399 15.9403C20.2273 15.8111 20.0831 15.7132 19.9213 15.6563Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 28H27.5",
    stroke: "#2C2E2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17C20.9183 17 24.5 13.4183 24.5 9C24.5 4.58172 20.9183 1 16.5 1C12.0817 1 8.5 4.58172 8.5 9C8.5 13.4183 12.0817 17 16.5 17Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.3333C17.0523 15.3333 17.5 14.8856 17.5 14.3333C17.5 13.781 17.0523 13.3333 16.5 13.3333C15.9477 13.3333 15.5 13.781 15.5 14.3333C15.5 14.8856 15.9477 15.3333 16.5 15.3333Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5003 11.3336V10.667C16.9618 10.667 17.4129 10.5301 17.7967 10.2737C18.1804 10.0173 18.4794 9.65293 18.656 9.22657C18.8326 8.80021 18.8789 8.33105 18.7888 7.87843C18.6988 7.42581 18.4766 7.01005 18.1502 6.68372C17.8239 6.3574 17.4082 6.13517 16.9555 6.04514C16.5029 5.95511 16.0338 6.00132 15.6074 6.17792C15.181 6.35453 14.8166 6.65359 14.5602 7.03731C14.3038 7.42102 14.167 7.87215 14.167 8.33364",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnythingElse2Icon);
export default __webpack_public_path__ + "static/media/anything-else2-icon.c4442d6cb459468d2f5b041fcf0a5b27.svg";
export { ForwardRef as ReactComponent };